export const getZoneInteractionProps = () => {
    return {
        action: 'action',
        zoneType: 'zone_type',
        zoneName: 'zone_name',
        pageName: 'page_name',
        zoneId: 'zone_id',
        zonePosition: 'zone_position',
        zoneLayout: 'zone_layout',
        ctaLabel: 'cta_label'
    };
};
